import "./App.css";
import ResultsPage from "./result/ResultsPage";
import React, { Component, Fragment } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./accounts/Login";
import Profile from "./accounts/Profile";
import Sign_up_form from "./accounts/sign_up_form";
import PrivateRoute from "./common/PrivateRoute";
import Home from "./homepage/Home";
import Alerts from "./layout/Alerts";
import AlertTemplate from "react-alert-template-basic";
import { Provider as AlertProvider, positions } from "react-alert";
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import { GoogleSignUpButton } from "./sign_up/components/GoogleSignUpButton";
import { GoogleSignInButton } from "./sign_in/components/GoogleSignInButton";
import ChangePass from "./accounts/ChangePass";
import BucketlistPage from "./bucketlist/BucketlistPage";
import NavigationBar from "./common/NavigationBar";
import PoiPage from "./poi/PoiPage";
import FromBucketlist from "./itin/FromBucketlist";
import Recommendation from "./itin/Recommendation";
import ItinChooseMethod from "./itin/ChooseMethod";
import { ItinPage } from "./itin/ItinPage";
import { ItinDetailPage, ItinDetailPageMode } from "./itin/ItinDetailPage";
import { CartPage } from "./cart/Cart";

const alertOptions = {
  timeout: 5000,
  position: positions.TOP_CENTER,
  offset: "90px",
};

class App extends Component {
  componentDidMount() {
    store.dispatch(loadUser());
    console.log("state", store.getState());
  }

  render() {
    return (
      <Provider store={store}>
        <AlertProvider template={AlertTemplate} {...alertOptions}>
          <Router>
            <Fragment>
              <Alerts />
              <div className="pages">
                <NavigationBar />
                <div className="content">
                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route
                      exact
                      path="/register-with-google"
                      component={GoogleSignUpButton}
                    />
                    <Route
                      exact
                      path="/sign-in-with-google"
                      component={GoogleSignInButton}
                    />
                    <PrivateRoute exact path="/profile" component={Profile} />
                    <Route exact path="/register" component={Sign_up_form} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/info" component={ResultsPage} />
                    <Route path="/poi/:id" component={PoiPage} />
                    <Route exact path="/itin" component={ItinPage} />
                    <Route exact path="/cart" component={CartPage} />
                    <PrivateRoute
                      exact
                      path="/itin/create"
                      component={ItinChooseMethod}
                    />
                    <PrivateRoute
                      exact
                      path="/itin/create/from-bucketlist"
                      component={FromBucketlist}
                    />
                    <PrivateRoute
                      exact
                      path="/itin/create/from-recommendation"
                      component={Recommendation}
                    />
                    <Route exact path="/itin/share/:username/:id">
                      <ItinDetailPage mode={ItinDetailPageMode.public} />
                    </Route>
                    <Route exact path="/itin/create/finalize">
                      <ItinDetailPage mode={ItinDetailPageMode.create} />
                    </Route>
                    <Route path="/itin/:id/edit">
                      <ItinDetailPage mode={ItinDetailPageMode.edit} />
                    </Route>
                    <Route path="/itin/:id">
                      <ItinDetailPage mode={ItinDetailPageMode.read} />
                    </Route>
                    <PrivateRoute
                      exact
                      path="/change-password"
                      component={ChangePass}
                    />
                    <PrivateRoute
                      exact
                      path="/bucketlist"
                      component={BucketlistPage}
                    />
                  </Switch>
                </div>
              </div>
            </Fragment>
          </Router>
        </AlertProvider>
      </Provider>
    );
  }
}

export default App;
